import type { Event } from 'models';
import { Alert } from 'ui';
import { isAfterJoinPeriod, isBeforeJoinPeriod } from '../../../utils';
import { useEventInviteRole } from './hooks';
import { SharedEventForm } from './shared-event-form';

type P = {
  event: Event;
  invitationToken: string;
};

const SharedEventEnter = ({ event, invitationToken }: P) => {
  const eventInviteRole = useEventInviteRole(invitationToken);

  if (!eventInviteRole) {
    return <Alert title="Access token is expired or invalid." type="warning" />;
  }

  if (isBeforeJoinPeriod(eventInviteRole, event.startTime)) {
    return;
  }

  if (isAfterJoinPeriod(event.endTime)) {
    return <Alert title="This event has ended" />;
  }

  return <SharedEventForm event={event} invitationToken={invitationToken} />;
};

export default SharedEventEnter;
